export default __webpack_public_path__ + "static/media/2_portugal-image.b4f60e15.jpg";